module.exports = __webpack_public_path__ + "img/高老师-1.2d133017.png";